<template>
    <div class="jobtype">
        <div class="group">
            <input
            class="radio"
            type="radio"
            id="Open"
            name="status"
            value="Open"
            @click="radioSelect('Open')"
            :checked="status=='Open'"
            :disabled="!perms.includes('130')"/>
            <label for="Open">Open</label>
        </div>
        <div class="group">
            <input
            class="radio"
            type="radio"
            id="Completed"
            name="status"
            value="Completed"
            @click="radioSelect('Completed')"
            :checked="status=='Completed'"
            :disabled="!perms.includes('130')"/>
            <label for="Completed">Completed</label>
        </div>
        <div class="group">
            <input
            class="radio"
            type="radio"
            id="Cancelled"
            name="status"
            value="Cancelled"
            @click="radioSelect('Cancelled')"
            :checked="status=='Cancelled'"
            :disabled="!perms.includes('130')"/>
            <label for="Cancelled">Cancelled</label>
        </div>
        <div v-if="perms.includes('106') || status=='Internal'" class="group">
            <input
            class="radio"
            type="radio"
            id="Internal"
            name="status"
            value="Internal"
            @click="radioSelect('Internal')"
            :checked="status=='Internal'"
            :disabled="!perms.includes('106')"/>
            <label for="Internal">Internal</label>
        </div>
        <div v-if="perms.includes('144') || status=='Prospect'" class="group">
            <input
            class="radio"
            type="radio"
            id="Prospect"
            name="status"
            value="Prospect"
            @click="radioSelect('Prospect')"
            :checked="status=='Prospect'"
            :disabled="!perms.includes('144')"/>
            <label for="Prospect">Prospect</label>
        </div>
        <div v-if="select=='Cancelled'" style="display: flex; margin-bottom:5px;">
            <p style="width: fit-content; margin:0px; margin-right: 10px;">Cancellation Reason: </p>
            <autocomplete style="flex-grow: 1;" v-model="cancelReason" :type="64"/> <!--64 : Cancellation reason-->
        </div>
        <div v-if="select=='Prospect' || select=='Internal' || select=='Cancelled' || select=='Open' && originalStatus=='Completed'" style="display: flex;">
            <p style="width: fit-content; margin:0px; margin-right: 10px;">Change Comment: </p>
            <input style="flex-grow: 1;" v-model="statusComment" @change="sendData()"/>
        </div>
    </div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    name: 'status',

    props: {
        index: Number,
        status: String,
    },

    data() {
        return {
			perms:[],
            select: '',
            cancelReason: '',
            statusComment: '',
            originalStatus: '',
        };
    },
    async created(){
		this.perms = api.getPerms();
        this.originalStatus = this.status;
        this.radioSelect(this.status);
    },
    methods: {
        radioSelect(value){
            this.select=value;
            this.sendData();
        },
        setData(value){
            if(this.search!=value) {
                this.search = value;
                if(this.use_radio){
                    document.getElementById('OTHER').checked=true;
                }
                this.radioSelect('OTHER');
            }
        },
        sendData(){
            this.$emit('input',  this.index, this.select, this.cancelReason, this.statusComment);
        }
    },
    watch:{
        cancelReason() {
            this.sendData();
        }
    }
};
</script>

<style>
.jobtype{
    position: relative;
    display:inline-block;
    width:100%;
}
.radio {
    width:25px;
}
.group{
    display:inline-block;
    margin-right:50px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/status.vue